import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";
import './RuleStrategyPage.css';
import RefreshButton from './RefreshButton';
import WatchlistStar from './WatchlistStar';

const RuleStrategyPage = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('3% Rule');
  const [filterBy, setFilterBy] = useState('Risk');
  const [topPerformers, setTopPerformers] = useState([]);
  const [lowPerformers, setLowPerformers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = () => {
    setLoading(true);
    setError(null);
    fetch(`${API_BASE_URL}/breakout-three-percent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ category: "fo" })
    })
      .then(res => res.json())
      .then(data => {
        if (data.top_performers || data.low_performers) {
          setTopPerformers(data.top_performers || []);
          setLowPerformers(data.low_performers || []);
        } else {
          setError("No data found");
        }
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="rule-strategy-page">
      {/* Header */}
      <header className="rule-strategy-header">
        <div className="rule-strategy-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" className="logo-text" />
          </div>

          <div className="rule-strategy-user">
            <RefreshButton 
              onRefresh={fetchData} 
              isLoading={loading}
              size="small"
              style={{ marginRight: '10px' }}
            />
            <button className="rule-strategy-back-btn" onClick={onBack}>
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="rule-strategy-main">
        <div className="rule-strategy-container">

          <div className="momentum-header-bar">
            <h1>Momentum Radar</h1>
            <div className="filter-buttons">
              <h3>Filter By: </h3>
              <button className="filter-btn active">F&O Stocks</button>
            </div>
          </div>

          {/* Strategy Rules */}
          <div className="spike-section">
            <h4>3% RULE STRATEGY</h4>
            <button className="btn green-btn">UP</button>
            <button className="btn red-btn">DOWN</button>
          </div>

          {/* Stock Table */}
          <div className="rule-strategy-table-container">
            <div className="table-header-info">
              <span className="results-count">
                Showing {topPerformers.length + lowPerformers.length} strategy trades
              </span>
            </div>

            {loading ? (
              <div className="loader-container"><div className="loader"></div></div>
            ) : error ? (
              <div className="table-row">{error}</div>
            ) : (
              <div className="rule-strategy-table">
                {/* Top Performers */}
                <h3>Top Performers</h3>
                <div className="table-row table-header-row">
                  <div className="table-cell">Stock</div>
                  <div className="table-cell">LTP</div>
                  <div className="table-cell">% Change</div>
                  <div className="table-cell">Proximity to High</div>
                </div>
                {topPerformers.map((stock, idx) => (
                  <div key={idx} className="table-row stock-row">
                    <div className="table-cell">
                      <WatchlistStar 
                        stock={{
                          symbol: stock.stock,
                          name: stock.stock,
                          ltp: stock.ltp,
                          percentage_change: stock.percentage_change,
                          proximity_to_high: stock.proximity_to_high
                        }} 
                        size="16px"
                      />
                      {stock.stock}
                    </div>
                    <div className="table-cell">₹{stock.ltp}</div>
                    <div className={`table-cell ${stock.percentage_change >= 0 ? 'positive' : 'negative'}`}>
                      {stock.percentage_change.toFixed(2)}%
                    </div>
                    <div className="table-cell">{stock.proximity_to_high?.toFixed(2)}</div>
                  </div>
                ))}

                {/* Low Performers */}
                <h3>Low Performers</h3>
                <div className="table-row table-header-row">
                  <div className="table-cell">Stock</div>
                  <div className="table-cell">LTP</div>
                  <div className="table-cell">% Change</div>
                  <div className="table-cell">Proximity to Low</div>
                </div>
                {lowPerformers.map((stock, idx) => (
                  <div key={idx} className="table-row stock-row">
                    <div className="table-cell">
                      <WatchlistStar 
                        stock={{
                          symbol: stock.stock,
                          name: stock.stock,
                          ltp: stock.ltp,
                          percentage_change: stock.percentage_change,
                          proximity_to_low: stock.proximity_to_low
                        }} 
                        size="16px"
                      />
                      {stock.stock}
                    </div>
                    <div className="table-cell">₹{stock.ltp}</div>
                    <div className={`table-cell ${stock.percentage_change >= 0 ? 'positive' : 'negative'}`}>
                      {stock.percentage_change.toFixed(2)}%
                    </div>
                    <div className="table-cell">{stock.proximity_to_low?.toFixed(2)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default RuleStrategyPage;
